module.exports = __webpack_public_path__ + "img/bg-sm-ft.6cf38c66.jpg";